import Chartjs from "@stimulus-components/chartjs"

export default class ChartjsController extends Chartjs {

}